module.exports = __webpack_public_path__ + "img/footer.62c5bcad.png";